// Money is stored as integer minor units (pesewas for GHS) with a currency
// code (SPEC section 7). Shown as "GHC 135" or "GHC 12.50" (SPEC section 11).

export const DEFAULT_CURRENCY = 'GHS';

const SYMBOLS: Record<string, string> = { GHS: 'GHC', NGN: 'NGN', KES: 'KES', USD: 'USD' };

export function formatMoney(minor: number, currency = DEFAULT_CURRENCY): string {
  const safe = Number.isFinite(minor) ? Math.round(minor) : 0;
  const sign = safe < 0 ? '-' : '';
  const absolute = Math.abs(safe);
  const major = Math.floor(absolute / 100);
  const cents = absolute % 100;
  const whole = major.toLocaleString('en-GB');
  return `${sign}${SYMBOLS[currency] ?? currency} ${cents ? `${whole}.${String(cents).padStart(2, '0')}` : whole}`;
}

// "12", "12.5", "12.50", "1,200" → minor units; null when it is not money.
export function parseMoneyInput(value: unknown): number | null {
  const text = String(value ?? '').replace(/[,\s]/g, '').replace(/^GH[CS]/i, '');
  if (!/^\d{1,9}(\.\d{1,2})?$/.test(text)) return null;
  const [whole = '0', fraction = ''] = text.split('.');
  return Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
}

export function toMinor(decimal: unknown): number {
  const value = Number(decimal);
  return Number.isFinite(value) ? Math.round(value * 100) : 0;
}

export function fromMinor(minor: number): number {
  return Math.round(minor) / 100;
}
